/*
 * @ProjectName: Union Service
 * @FileName:
 * @PackageName:
 * @Author: Zhanglei
 * @Date: 2020-08-20 15:41:35
 * @LastEditTime: 2020-08-21 22:17:14
 * @LastEditors: Zhanglei
 * @Description:
 * @FilePath: /desktop/src/store/modules/audit.js
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
 */
import {
  getTableHeaderApi,
  getTableDataApi,
  getChangeDataApi,
  deleteDataApi,
  postDataApi,
  getUserApi,
  getUserItemApi
} from "@/service/auditService";

const audit = {
  state: {},
  mutations: {},
  getters: {},
  actions: {
    getAuditHeader(store, id) {
      return new Promise((resolve, reject) => {
        getTableHeaderApi(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getAuditData(store, idInfo) {
      return new Promise((resolve, reject) => {
        getTableDataApi(idInfo)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    getChangeAuditData(store, data) {
      return new Promise((resolve, reject) => {
        getChangeDataApi(data)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    deleteAuditData(store, id) {
      return new Promise((resolve, reject) => {
        deleteDataApi(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    postAuditData(store, data) {
      return new Promise((resolve, reject) => {
        postDataApi(data)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getAuditUser(store, id) {
      return new Promise((resolve, reject) => {
        getUserApi(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getAuditUserItem(store, id) {
      return new Promise((resolve, reject) => {
        getUserItemApi(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};

export default audit;



// WEBPACK FOOTER //
// ./src/store/modules/audit.js